import React from 'react'
import MaterialSymbol from '../material-symbol'

const Star = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="star" {...props} />
))

Star.displayName = 'Star'

export default Star
